import Vue from 'vue'
import Router from 'vue-router'
import RouterCommon from "./common" // 引入通用模块
import exhibitionModule from "./modules/exhibition"
import museumModule from "./modules/museum"
import buildingModule from "./modules/building"
import serviceModule from "./modules/service"
import { Dialog } from 'vant'


Vue.use(Router)
var routes = [
    ...RouterCommon,
    ...exhibitionModule,
    ...museumModule,
    ...buildingModule,
    ...serviceModule
];

var router = new Router({
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

/**
 * 微信环境判断
 */
const isWxEnv = () => {
    let ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
};
/**
* 获取token
*/
const getCookie = cname => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

router.beforeEach(function (to, from, next) {
    if (window.toast) window.toast.clear();
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.meta.needLogin && !getCookie('api_token') && process.env.NODE_ENV == 'production') {
        if (!isWxEnv()) {
            Dialog.alert({
                title: '提示',
                message: '请在微信环境下使用'
            }).then(() => {
                // on close
            });
        } else {

            location.href = "/wx_oauth?vue_url=" + window.location.hash.replace('#', '')
        }
    } else {

        next()
    }
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js